import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { PocList } from 'commons/components/components-wrapper/poc-list.component';
import { PocListItem } from 'commons/components/components-wrapper/poc-list-item.component';
import { AlarmsBadgeComponent } from 'commons-app/components';
import { useAppContext } from 'core/contexts/app.provider.context';
import { useUserPreferencesContext } from 'core/contexts/user-preferences/hooks/use-user-preferences-context.hook';
import { useTranslation } from 'core/i18n';
import { UserCustomFilter, UserCustomFilterTypes } from 'core/utils/types/user-custom-filter.type';
import { OperatorsFilterFields } from 'modules/operators/types/operators-filter.type';
import { memo } from 'react';
import { getFilterByFieldValue } from '../app.menu.business';
import { SideMenuListItem } from '../app.menu.style';
import { MenuProps } from '../app.menu.type';
import { MenuFilterItem } from './filter-item-menu.component';

export const OperatorsMenu: React.FC<MenuProps> = memo(
    ({ selected, menuVisible, onNavigationClick, onExpandedChange }: MenuProps) => {
        const { t } = useTranslation();
        const { sideMenuAlarms } = useAppContext();
        const { sideMenuEntries } = useUserPreferencesContext();

        const handleClick = (e: React.MouseEvent<HTMLElement>) => {
            if ((e.target as HTMLElement).closest('owc-icon-button')) {
                return;
            }
            onNavigationClick('operators');
        };

        const handleExpand = () => {
            onExpandedChange?.(!menuVisible);
        };

        return (
            <SideMenuListItem
                value="operators"
                data-testid="operators-menu-item"
                variant="side-menu"
                selected={selected === `operators`}
                onClick={handleClick}
                onExpandedChange={handleExpand}
                size="medium"
                expanded={menuVisible}
            >
                <PocIcon slot="prefix" name="user_group" family="filled" />
                {t('app.sidemenu.options.operators')}

                <div slot="suffix" style={{ marginRight: '8px' }}>
                    <AlarmsBadgeComponent alarms={sideMenuAlarms['operators']} />
                </div>

                <PocList slot="children">
                    {sideMenuEntries
                        ?.filter((filter: UserCustomFilter<OperatorsFilterFields>) =>
                            getFilterByFieldValue?.(filter, UserCustomFilterTypes.OPERATORS, 'active', true)
                        )
                        .map((sideMenuEntry) => (
                            <MenuFilterItem
                                key={sideMenuEntry.id}
                                filter={sideMenuEntry}
                                module={UserCustomFilterTypes.OPERATORS}
                                sideMenuAlarms={sideMenuAlarms}
                                showBadge={sideMenuEntry.fields.active}
                            />
                        ))}
                    <PocListItem
                        variant="side-menu"
                        data-testid="operators-deactivated-menu-item"
                        value="operators/filters/deactivate"
                        size="medium"
                        className={selected === `operators/filters/deactivate` ? 'selected' : ''}
                    >
                        {t('app.sidemenu.options.operators.deactivated')}
                    </PocListItem>
                    {sideMenuEntries
                        ?.filter((filter: UserCustomFilter<OperatorsFilterFields>) =>
                            getFilterByFieldValue?.(filter, UserCustomFilterTypes.OPERATORS, 'active', false)
                        )
                        .map((sideMenuEntry) => (
                            <MenuFilterItem
                                key={sideMenuEntry.id}
                                filter={sideMenuEntry}
                                module={UserCustomFilterTypes.OPERATORS}
                                sideMenuAlarms={sideMenuAlarms}
                                showBadge={sideMenuEntry.fields.active}
                            />
                        ))}
                </PocList>
            </SideMenuListItem>
        );
    }
);
